export default {
  myLocation: {
    stopShowingCurrentLocation: 'Klicken um meinen Standort nicht mehr anzuzeigen',
    showCurrentLocation: 'Klicken für meinen Standort',
    yourCurrentLocation: 'Mein Standort',
    continuously: 'Permanent',
    onlyOnce: 'Einmal',
    continuouslyLocation: 'Meinen Standort alle 2 Sekunden abfragen',
    onlyOnceLocation: 'Meinen Standort nur jetzt bestimmen',
    myPositionToolTip: 'Standort aktivieren um Position zu zeigen und einfacher Orte in der Nähe zu finden'
  }
}
